/**
 * Company: SPHMedia
 * Description: [Brightcove Video Player component for playlist videos]
 */

import { BrightcoveVideo } from "@components/Blocks/BrightcoveVideo/BrightcoveVideo";
import { BC_PLAYLIST_PLAYER_ID } from "@helper/getEnvVariables";
import type { BrightcovePlayer } from "@typings/Brightcove.d";
import { ReactElement, RefObject } from "react";

type PlaylistVideoPlayerProps = {
  playlistId: string;
  forwardedRef: RefObject<HTMLDivElement | null>;
  onEnded?: () => void;
  nextPlaylist?: () => void;
  playerStyle?: string;
  handlePlayerReady?: (player: BrightcovePlayer) => void;
  syncMuteAcrossPlayers?: boolean;
};

/**
 * PlaylistVideoPlayer
 * Description: [Brightcove Video Player component for playlist videos]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function PlaylistVideoPlayer({
  playlistId,
  forwardedRef,
  onEnded,
  nextPlaylist,
  playerStyle,
  handlePlayerReady,
  syncMuteAcrossPlayers = true,
}: PlaylistVideoPlayerProps): ReactElement {
  return (
    <BrightcoveVideo
      videoId="landscape-playlist"
      forwardedRef={forwardedRef}
      onEnded={onEnded}
      nextPlaylist={nextPlaylist}
      playerStyle={playerStyle}
      playerId={BC_PLAYLIST_PLAYER_ID}
      playlistId={playlistId}
      onPlayerReady={handlePlayerReady}
      syncMuteAcrossPlayers={syncMuteAcrossPlayers}
    />
  );
}
